import React from 'react'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
const PREFIX = 'SecondaryButton'

const classes = {
    root: `${PREFIX}-root`,
    root2: `${PREFIX}-root2`,
}

const Root = styled('div')(({ theme }) => ({
    [`& .${classes.root2}`]: {
        '& > *': {
            width: '100%',
            height: '60px',
        },
    },
}))

const ColorButton = Button

const SecondaryButton = (props) => {
    const { t } = useTranslation()
    return (
        <Root className={`${classes.root} ${props.btnSize} secButton`}>
            <ColorButton
                variant="outlined"
                color="primary"
                onClick={props.onClick}
                id={props.id}
                type={props.type}
                disabled={props.disabled || false}
                classes={{
                    root: classes.root,
                }}
            >
                {props.iconLeft}
                {t(props.label)}
                {props.children}
            </ColorButton>
        </Root>
    )
}

export default SecondaryButton
